import React, { lazy, Suspense } from "react";
import Header from "./components/Header";
import MainContent from "./components/MainContent";
import Footer from "./components/Footer";
import { TextosProvider } from "./components/TextosContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { ToastContainer, toast } from "react-toastify";

//Página Contactos
const Contactos = lazy(() => import("./Pages/Contactos"));
//Páginas SCMT
const Historia = lazy(() => import("./Pages/Historia"));
const Missao = lazy(() => import("./Pages/Missao_e_Valores"));
const CorposGerentes = lazy(() => import("./Pages/Corpos_Gerentes"));
const MensagemProvedor = lazy(() => import("./Pages/Mensagem_do_Provedor"));
const Irmandade = lazy(() => import("./Pages/Irmandade"));
const Galeria = lazy(() => import("./Pages/Galeria_de_Fotos"));
const Voluntariado = lazy(() => import("./Pages/Voluntariado"));
const Noticias = lazy(() => import("./Pages/Noticias"));
const Noticia = lazy(() => import("./Pages/Noticia"));
const Documentos = lazy(() => import("./Pages/Documentos"));
const Saude = lazy(() => import("./Pages/Saude"));
const FAQ = lazy(() => import("./Pages/FAQ"));
const Social = lazy(() => import("./Pages/Social"));
const Jornais = lazy(() => import("./Pages/Jornais"));
const Valencia = lazy(() => import("./Pages/Valencia"));
const Developers = lazy(() => import("./Pages/Developers"));
const CanalDenuncias = lazy(() => import("./Pages/CanalDenuncias"));
const PrevencaoCorrupcao = lazy(() => import("./Pages/PrevencaoCorrupcao"));
const Cultura = lazy(() => import("./Pages/Cultura"));
const ApoioCultural = lazy(() => import("./Pages/Apoio_Cultural"));
const Geral = lazy(() => import("./Pages/Geral"));
const Protocolos = lazy(() => import("./Pages/Protocolos"));

const App = () => {
  const showToast = () => {
    toast.success("Notificação de sucesso!");
    // Pode ser outro tipo, como toast.error(), toast.info(), etc.
  };
  return (
    <TextosProvider>
    <Router>
      <Header />
      <div className="page-wrapper">
        <main className="main-content">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<MainContent />} />
              <Route path="/developers" element={<Developers />} />
              <Route path="/canal-denuncias" element={<CanalDenuncias />} />
              <Route
                path="/prevencao-corrupcao"
                element={<PrevencaoCorrupcao />}
              />
              <Route path="/contactos" element={<Contactos />} />
              {/* SCMT */}
              <Route path="/scmt/historia" element={<Historia />} />
              <Route path="/scmt/missao-e-valores" element={<Missao />} />
              <Route
                path="/scmt/corpos-gerentes"
                element={<CorposGerentes />}
              />
              <Route
                path="/scmt/mensagem-do-provedor"
                element={<MensagemProvedor />}
              />
              <Route path="/scmt/irmandade" element={<Irmandade />} />
              <Route path="/scmt/galeria-de-fotos" element={<Galeria />} />
              <Route path="/scmt/voluntariado" element={<Voluntariado />} />
              <Route path="/scmt/protocolos" element={<Protocolos />} />
              <Route path="/scmt/cultura" element={<Cultura />} />
              {/* Notícias */}
              <Route path="/noticias/imprensa" element={<Noticias />} />
              <Route
                path="/noticias/jornal-a-voz-do-nabao"
                element={<Jornais />}
              />
              <Route path="/noticias/:id" element={<Noticia />} />
              {/* Documentos */}
              <Route path="/documentos/:id" element={<Documentos />} />
              {/* Valências */}
              <Route path="/valencias/saude" element={<Saude />} />
              <Route path="/valencias/social" element={<Social />} />
              <Route path="/valencias/cultura" element={<ApoioCultural />} />
              <Route path="/valencias/geral" element={<Geral />} />
              <Route path="/valencia/:id" element={<Valencia />} />
              {/* Outros */}
              <Route path="/faq" element={<FAQ />} />
              {/* Fallback */}
              <Route
                path="*"
                element={<div>404 - Página não encontrada</div>}
              />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
      {/* ToastContainer que irá renderizar as notificações */}
      <ToastContainer
        position="top-right" // Posição do toast
        autoClose={5000} // Tempo até desaparecer
        hideProgressBar={false} // Mostrar a barra de progresso
        newestOnTop={true} // Toasts mais novos em cima
        closeOnClick
        pauseOnHover
      />
    </Router>
    </TextosProvider>
  );
};

export default App;
